import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import SigSDK from '@wacom/signature-sdk';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-signature',
  standalone: false,
  templateUrl: './signature.component.html',
  styleUrl: './signature.component.scss'
})
export class SignatureComponent implements OnInit, OnDestroy {
  @Input() label: string;

  @Output() acceptSignatureEvent = new EventEmitter<any>();

  // Capture Tab
  @ViewChild('allow_mouse_check') allowMouseCheckRef!: ElementRef;
  @ViewChild('allow_touch_check') allowTochCheckRef!: ElementRef;
  @ViewChild('allow_pen_check') allowPenCheckRef!: ElementRef;
  @ViewChild('selectedStuDevice') selectedStuDeviceRef!: ElementRef;
  @ViewChild('capture_stu_btn') captureSTUBtnRef!: ElementRef;
  @ViewChild('capture_canvas_btn') captureCanvasBtnRef!: ElementRef;
  @ViewChild('captureDiv') captureDivRef!: ElementRef;
  @ViewChild('signatureImage') signatureImageRef!: ElementRef;
  @ViewChild('save_image_btn') saveImageBtnRef!: ElementRef;
  @ViewChild('save_text_btn') saveTextBtnRef!: ElementRef;
  @ViewChild('save_binary_btn') saveBinaryBtnRef!: ElementRef;
  @ViewChild('save_iso_btn') saveIsoBtnRef!: ElementRef;

  // Settings Tab
  @ViewChild('encrypt_stu') encryptStuCheckedRef!: ElementRef;
  @ViewChild('ink_width') inkWidthRef!: ElementRef;
  @ViewChild('rendering_color_box') renderingColorBoxRef!: ElementRef;
  @ViewChild('background_color_box') backgroundColorBoxRef!: ElementRef;
  @ViewChild('put_background_image') putBackgroundImageRef!: ElementRef;
  @ViewChild('background_image') backgroundImageRef!: ElementRef;
  @ViewChild('background_image_mode') backgroundImageModeRef!: ElementRef;
  @ViewChild('background_opacity') backgroundOpacityRef!: ElementRef;
  @ViewChild('allowOutSide') allowOutSideRef!: ElementRef;
  @ViewChild('allowZeroPressure') allowZeroPressureRef!: ElementRef;
  @ViewChild('dialog_width') dialogWidthRef!: ElementRef;
  @ViewChild('dialog_height') dialogHeightRef!: ElementRef;
  @ViewChild('stu_fit_mode') fitModeRef!: ElementRef;
  @ViewChild('shows_modal') showsModalRef!: ElementRef;
  @ViewChild('shows_as_dialog') showsAsDialogRef!: ElementRef;
  @ViewChild('dialog_left') dialogLeftRef!: ElementRef;
  @ViewChild('dialog_top') dialogTopRef!: ElementRef;
  @ViewChild('is_centered') isCenteredRef!: ElementRef;
  @ViewChild('is_draggable') isDraggableRef!: ElementRef;
  @ViewChild('border_color_box') borderColorBoxRef!: ElementRef;
  @ViewChild('border_width_box') borderWidthBoxRef!: ElementRef;
  @ViewChild('has_title_check') hasTitleCheckRef!: ElementRef;
  @ViewChild('title_text') titleTextRef!: ElementRef;
  @ViewChild('show_signatory_check') showSignatoryCheckRef!: ElementRef;
  @ViewChild('signatory_font_type_text') signatoryFontTypeTextRef!: ElementRef;
  @ViewChild('signatory_font_size_text') signatoryFontSizeTextRef!: ElementRef;
  @ViewChild('signatory_offset_x_text') signatoryOffsetXTextRef!: ElementRef;
  @ViewChild('signatory_offset_y_text') signatoryOffsetYTextRef!: ElementRef;
  @ViewChild('signatory_color_box') signatoryColorBoxRef!: ElementRef;
  @ViewChild('show_reason_check') showReasonCheckRef!: ElementRef;
  @ViewChild('reason_font_type_text') reasonFontTypeTextRef!: ElementRef;
  @ViewChild('reason_font_size_text') reasonFontSizeTextRef!: ElementRef;
  @ViewChild('reason_offset_x_text') reasonOffsetXTextRef!: ElementRef;
  @ViewChild('reason_offset_y_text') reasonOffsetYTextRef!: ElementRef;
  @ViewChild('reason_color_box') reasonColorBoxRef!: ElementRef;
  @ViewChild('show_date_check') showDateCheckRef!: ElementRef;
  @ViewChild('date_font_type_text') dateFontTypeTextRef!: ElementRef;
  @ViewChild('date_font_size_text') dateFontSizeTextRef!: ElementRef;
  @ViewChild('date_offset_x_text') dateOffsetXTextRef!: ElementRef;
  @ViewChild('date_offset_y_text') dateOffsetYTextRef!: ElementRef;
  @ViewChild('date_color_box') dateColorBoxRef!: ElementRef;
  @ViewChild('show_signing_line_check') showSigningLineCheckRef!: ElementRef;
  @ViewChild('signing_line_left_text') signingLineLeftTextRef!: ElementRef;
  @ViewChild('signing_line_right_text') signingLineRightTextRef!: ElementRef;
  @ViewChild('signing_line_width_text') signingLineWidthTextRef!: ElementRef;
  @ViewChild('signing_line_offset_y_text') signingLineOffsetYTextRef!: ElementRef;
  @ViewChild('signing_line_color_box') signingLineColorBoxRef!: ElementRef;
  @ViewChild('button_font_type') buttonFontTypeRef!: ElementRef;
  @ViewChild('button_list_div') buttonListDivRef!: ElementRef;
  @ViewChild('render_width') renderWidthRef!: ElementRef;
  @ViewChild('render_height') renderHeightRef!: ElementRef;
  @ViewChild('is_relative') isRelativeRef!: ElementRef;
  @ViewChild('no_encryption') noEncryptionRef!: ElementRef;
  @ViewChild('symmetric_encryption') symmetricEncryptionRef!: ElementRef;
  @ViewChild('symmetric_password') symmetricPasswordRef!: ElementRef;
  @ViewChild('asymmetric_encryption') asymmetricEncryptionRef!: ElementRef;
  @ViewChild('public_key') publicKeyRef!: ElementRef;
  @ViewChild('private_key_password') privateKeyPasswordRef!: ElementRef;
  @ViewChild('private_key') privateKeyRef!: ElementRef;
  @ViewChild('iso_type') isoTypeRef!: ElementRef;  
  @ViewChild('enable_timeout') enableTimeoutRef!: ElementRef;
  @ViewChild('timeOutValue') timeOutValueRef!: ElementRef;
  @ViewChild('emptyTimeOut') emptyTimeOutRef!: ElementRef;
  @ViewChild('dataTimeOut') dateTimeOutRef!: ElementRef;
  @ViewChild('minTimeOnSurface') minTimeOnSurfaceRef!: ElementRef;

  @ViewChild('clear_btn_div_default') clearBtnDivDefaultRef!: ElementRef;
  @ViewChild('cancel_btn_div_default') cancelBtnDivDefaultRef!: ElementRef;
  @ViewChild('accept_btn_div_default') acceptBtnDivDefaultRef!: ElementRef;

  private backgroundImage?: HTMLImageElement;
  private buttonActions: any = {
    clear: this.clear.bind(this),
    accept: this.accept.bind(this),
    cancel: this.cancel.bind(this),
  };
  private documentHash: any = null;
  private sigCaptDialog?: any;
  private sigObj?: any;
  private sigSDK?: any;
  private stuCaptDialog?: any;
  private stuDevice?: any;
  private stuReady: boolean = false;

  async ngOnInit() {
    // WACOM PARAMS
    this.sigSDK = await SigSDK({
      locateFile: (path: string) => `/assets/wacom/${path}`
    });
    this.sigObj = new this.sigSDK.SigObj();
    
    try {
      await this.sigObj?.setLicence(
        environment.wacom.licenseKey,
        environment.wacom.licenseSecret
      );		  
      if (this.sigSDK?.STUDevice.isHIDSupported()) {
        this.captureSTUBtnRef.nativeElement.disabled = false;
      }      
      this.captureCanvasBtnRef.nativeElement.disabled = false;
      this.setDeviceName();
      setTimeout(() => {
        this.capture(environment.wacom.mouse ? 'Canvas' : 'STU');
      });
    } catch (error) {
      alert(error);
    }
  }

  ngOnDestroy(): void {
    this.cancel();
  }

  // WACOM FUNCTIONS
  public capture(source: string): void {
    if (!(this.showsAsDialogRef.nativeElement as HTMLInputElement).checked) {
      const captureDiv: HTMLDivElement = this.captureDivRef.nativeElement;
      captureDiv.style.width = (this.dialogWidthRef.nativeElement as HTMLInputElement).value+"px";
      captureDiv.style.height = (this.dialogHeightRef.nativeElement as HTMLInputElement).value+"px";
    }

    this.signatureImageRef.nativeElement.style.display = "none";
    this.captureDivRef.nativeElement.style.display = "block";

    this.saveImageBtnRef.nativeElement.disabled = true;
    this.saveTextBtnRef.nativeElement.disabled = true;
    this.saveBinaryBtnRef.nativeElement.disabled = true;
    this.saveIsoBtnRef.nativeElement.disabled = true;

    if (source === "STU") {
      this.captureFromSTU();
    } else {
      this.captureFromCanvas();
    }
  }

  private async captureFromCanvas() {
    this.stuCaptDialog = undefined;
    const outer = this;    
    const config = await this.generateConfig();
    config.source.mouse = this.allowMouseCheckRef.nativeElement.checked;
    config.source.touch = this.allowTochCheckRef.nativeElement.checked;
    config.source.pen = this.allowPenCheckRef.nativeElement.checked;
    this.sigCaptDialog = new this.sigSDK.SigCaptDialog(config);
    this.sigCaptDialog?.addEventListener(this.sigSDK.EventType.OK, async function() {
      outer.deleteConfig(config);
      outer.encryptSignature();
      outer.renderSignature();
    });

    this.sigCaptDialog?.addEventListener(this.sigSDK.EventType.CLEAR, async function() {
      console.log("canvas cleared");
    });

    const integrityType = this.sigSDK.KeyType.SHA512;
    this.sigCaptDialog?.open(this.sigObj!!, '', '', new this.sigSDK.ExtraData(), integrityType, this.documentHash);
    this.sigCaptDialog?.startCapture();
  }

  private async captureFromSTU() {
    this.stuReady = false;
    this.sigCaptDialog = undefined;
    const config = await this.generateConfig();    
    config.showWait = true;
    config.encryptSTU = this.encryptStuCheckedRef.nativeElement.checked;    

    const stuDeviceStr = localStorage.getItem("stuDevice");
    let stuDevice : any;
    if (!stuDeviceStr) {
      const devices = await this.sigSDK?.STUDevice.requestDevices();
      if (devices.length > 0) {
        stuDevice = devices[0];                        					
        localStorage.setItem("stuDevice", 
          JSON.stringify({"vendorId":stuDevice.vendorId,
            "productName":stuDevice.productName,
            "productId":stuDevice.productId
          }));
        this.setDeviceName();
      } else {
        throw "No STU devices found";
      }	
    } else {
      const deviceSaved = JSON.parse(stuDeviceStr);
      const allowedDevices = await this.sigSDK?.STUDevice.getDevices();
      allowedDevices.some((device: any) => {
        if (deviceSaved.vendorId === device.vendorId && deviceSaved.productId === device.productId && deviceSaved.productName === device.productName) {
          stuDevice = device;
          return true;
        }
        return false;
      })
    }

    const outer = this;
    this.stuDevice = new this.sigSDK.STUDevice(stuDevice);  
    this.stuCaptDialog = new this.sigSDK.StuCaptDialog(this.stuDevice, config);
    this.stuCaptDialog?.addEventListener(this.sigSDK.EventType.OK, async function() {
      console.log("on ok pressed");
      outer.deleteConfig(config);
      outer.encryptSignature();
      outer.renderSignature();
    });

    this.stuCaptDialog?.addEventListener(this.sigSDK.EventType.CLEAR, async function() {
      console.log("on clear pressed");
      outer.stuReady = true;
    });

    this.stuCaptDialog?.addEventListener(this.sigSDK.EventType.CANCEL, async function() {
      console.log("on cancel pressed");
    });

    const integrityType = this.sigSDK.KeyType.SHA512;
    await this.stuCaptDialog?.open(
      this.sigObj!!, '', '', new this.sigSDK.ExtraData(), integrityType, this.documentHash
    );
    this.stuReady = true;
  }

  private setDeviceName(): void {
    const stuDeviceStr = localStorage.getItem("stuDevice");
    if (stuDeviceStr) {
      this.selectedStuDeviceRef.nativeElement.innerHTML = JSON.parse(stuDeviceStr).productName;
    } else {
      this.selectedStuDeviceRef.nativeElement.innerHTML = "None";
    }
  }

  public removeDevice(): void {
    localStorage.removeItem("stuDevice");
    this.setDeviceName();
  }

  private async generateConfig(): Promise<any> {
    const config: any = new this.sigSDK.Config();
    config.strokeSize = this.inkWidthRef.nativeElement.value;
    config.strokeColor = this.renderingColorBoxRef.nativeElement.value;
    config.left = undefined;
    config.top = undefined;
    config.centered = false;
    config.useSTUScaling = false;
    config.title = this.titleTextRef.nativeElement.value;
    config.borderColor = this.borderColorBoxRef.nativeElement.value;
    config.borderWidth = this.borderWidthBoxRef.nativeElement.value;
    config.hasTitle = this.hasTitleCheckRef.nativeElement.checked;

    config.fitMode = this.sigSDK?.FIT_MODE.FIXED;

    config.signatory.visible = this.showSignatoryCheckRef.nativeElement.checked;
    config.signatory.fontFace = this.signatoryFontTypeTextRef.nativeElement.value;
    config.signatory.fontSize = this.signatoryFontSizeTextRef.nativeElement.value;
    config.signatory.offsetX = this.signatoryOffsetXTextRef.nativeElement.value;
    config.signatory.offsetY = this.signatoryOffsetYTextRef.nativeElement.value;
    config.signatory.color = this.signatoryColorBoxRef.nativeElement.value;
    
    config.reason.visible = this.showReasonCheckRef.nativeElement.checked;
    config.reason.fontFace = this.reasonFontTypeTextRef.nativeElement.value;
    config.reason.fontSize = this.reasonFontSizeTextRef.nativeElement.value;
    config.reason.offsetX = this.reasonOffsetXTextRef.nativeElement.value;
    config.reason.offsetY = this.reasonOffsetYTextRef.nativeElement.value;
    config.reason.color = this.reasonColorBoxRef.nativeElement.value;

    config.date.visible = this.showDateCheckRef.nativeElement.checked;
    config.date.fontFace = this.dateFontTypeTextRef.nativeElement.value;
    config.date.fontSize = this.dateFontSizeTextRef.nativeElement.value;
    config.date.offsetX = this.dateOffsetXTextRef.nativeElement.value;
    config.date.offsetY = this.dateOffsetYTextRef.nativeElement.value;
    config.date.color = this.dateColorBoxRef.nativeElement.value;

    config.signingLine.visible = this.showSigningLineCheckRef.nativeElement.checked;
    config.signingLine.left = this.signingLineLeftTextRef.nativeElement.value;
    config.signingLine.right = this.signingLineRightTextRef.nativeElement.value;
    config.signingLine.width = this.signingLineWidthTextRef.nativeElement.value;
    config.signingLine.offsetY = this.signingLineOffsetYTextRef.nativeElement.value;
    config.signingLine.color = this.signingLineColorBoxRef.nativeElement.value;

    config.buttonsFont = this.buttonFontTypeRef.nativeElement.value;
    const fields = this.buttonListDivRef.nativeElement.getElementsByTagName("fieldset");
    for (let i=0; i<fields.length; i++) {
      const button = new this.sigSDK.Button();     
      button.text = fields[i].elements.namedItem("button_text").value;
      button.textColor = fields[i].elements.namedItem("button_text_color").value;
      button.backgroundColor = fields[i].elements.namedItem("button_background_color").value;
      button.borderColor = fields[i].elements.namedItem("button_border_color").value;
      button.borderWidth = fields[i].elements.namedItem("button_border_width").value;

      const actionName = fields[i].elements.namedItem("button_action").value;
      button.onClick = this.buttonActions[actionName];

      config.buttons?.push_back(button);
    }

    if (!this.showsAsDialogRef.nativeElement.checked) {
      config.attachTo = this.captureDivRef.nativeElement.id;
    }

    config.background.color = this.backgroundColorBoxRef.nativeElement.value;
    config.background.alpha = this.backgroundOpacityRef.nativeElement.value*0.01;
    if (this.putBackgroundImageRef.nativeElement.checked && this.backgroundImage) {
      config.background.image = this.backgroundImage;
    }
    
    switch (this.backgroundImageModeRef.nativeElement.selectedIndex) {
      case 0: config.background.mode = this.sigSDK.BackgroundImageMode.NONE; break;
      case 1: config.background.mode = this.sigSDK.BackgroundImageMode.FIT; break;
      case 2: config.background.mode = this.sigSDK.BackgroundImageMode.CENTER; break;
      case 3: config.background.mode = this.sigSDK.BackgroundImageMode.PATTERN; break;
    }

    if (!this.allowOutSideRef.nativeElement.checked) {
      const self = this;
      config.onOutSide = function() {
        alert("Outside stroke is not allowed. Please sign again");
        self.clear();
        return true;
      }
    }

    config.allowZeroPressure = this.allowZeroPressureRef.nativeElement.checked;    

    const [browserInfo, osInfo] = await this.getSystemInfo();
    config.digitizerInfo = browserInfo;
    config.osInfo = osInfo;

    return config;
  }

  private deleteConfig(config: any): void {
    for (let i=0; i<config.buttons?.size()!!; i++) {
      config.buttons?.get(i)?.delete();
    }
    config.delete;
  }

  private async clear() {
    if (this.sigCaptDialog) {
      await this.sigCaptDialog.clear();
    }

    if (this.stuCaptDialog) {
      if (this.stuReady) {
        this.stuReady = false;
        this.stuCaptDialog.clear();
      }
    }
  }

  private async cancel() {
    if (this.sigCaptDialog) {
      this.sigCaptDialog?.cancel();
    }

    if (this.stuCaptDialog && this.stuReady) {
      await this.stuCaptDialog.cancel();
    }
  }

  private async accept() {
    if (this.sigCaptDialog) {
      this.sigCaptDialog.accept();
    }

    if (this.stuCaptDialog) {
      await this.stuCaptDialog.accept();
    }
  }

  private async renderSignature() {
    const image = await this.renderSignatureImage();

    this.captureDivRef.nativeElement.style.display = "none";
    this.signatureImageRef.nativeElement.src = image;
    this.signatureImageRef.nativeElement.style.display = "block";

    this.saveImageBtnRef.nativeElement.disabled = false;
    this.saveTextBtnRef.nativeElement.disabled = false;
    this.saveBinaryBtnRef.nativeElement.disabled = false;
    this.saveIsoBtnRef.nativeElement.disabled = false;

    this.acceptSignatureEvent.emit(this.signatureImageRef.nativeElement.src);
  }

  private async renderSignatureImage() {
    let renderWidth = this.renderWidthRef.nativeElement.value;
    let renderHeight = this.renderHeightRef.nativeElement.value;
    const isRelative = this.isRelativeRef.nativeElement.checked;
    
    let renderFlags = this.sigSDK.RenderFlags.RenderEncodeData.value;
    if (isRelative) {				
      renderFlags |= this.sigSDK.RenderFlags.RenderRelative.value;
      const sx = (96/25.4)*2;
      renderWidth = Math.floor(this.mmToPx(this.sigObj?.getWidth(true)!!/100) + sx);
      renderHeight = Math.floor(this.mmToPx(this.sigObj?.getHeight(true)!!/100) + sx);
    } else {
      if (isNaN(renderWidth) || renderWidth <= 0) {
        if (isNaN(renderHeight) || renderHeight <= 0) {
          renderWidth = this.mmToPx(this.sigObj?.getWidth(false)!!/100);
          renderHeight = this.mmToPx(this.sigObj?.getHeight(false)!!/100);
        } else {
          const originalRenderWidth = this.mmToPx(this.sigObj?.getWidth(true)!!/100);
          const originalRenderHeight = this.mmToPx(this.sigObj?.getHeight(true)!!/100);
          renderWidth = (originalRenderWidth/originalRenderHeight)*renderHeight;
        }
      } else if (isNaN(renderHeight) || renderHeight <= 0) {
        const originalRenderWidth = this.mmToPx(this.sigObj?.getWidth(true)!!/100);
        const originalRenderHeight = this.mmToPx(this.sigObj?.getHeight(true)!!/100);
        renderHeight = (originalRenderHeight/originalRenderWidth)*renderWidth;
      }
    
      renderWidth = Math.floor(renderWidth);
      renderHeight = Math.floor(renderHeight);				
      renderWidth += renderWidth % 4;
    }															
    
    const backgroundColor = "white";
    
    if (isRelative) {
        renderWidth = -96;
      renderHeight = -96;
    }
    
    const inkColor = this.renderingColorBoxRef.nativeElement.value;
    const inkWidth = this.inkWidthRef.nativeElement.value;
    const image = await this.sigObj?.renderBitmap(renderWidth, renderHeight, "image/png", inkWidth, inkColor, backgroundColor, 0, 0, renderFlags);	
    return image;	
  }

  private mmToPx(mm : number) : number {
    var dpr = window.devicePixelRatio;
    var inch = 25.4;
    var ppi = 96;	
    return ((mm/inch)*ppi)/dpr;
  }

  public async saveSignature(format: string) {
	  const newLink = document.createElement("a");			    
				
		if (format == "image") {
		  newLink.download = "signature.png";
			newLink.href = this.signatureImageRef.nativeElement.src;
		} else {
		  let blob;
			if (format == "txt") {
			  newLink.download = "signature.txt";
				blob = new Blob([await this.sigObj?.getTextData(this.sigSDK.TextFormat.BASE64)], { type: "text/plain" });
			} else if (format == "binary") {
			  newLink.download = "signature.fss";
				blob = new Blob([await this.sigObj?.getSigData()], { type: "application/octet-stream" });
			} else if (format == "iso") {
        let name;
        let isoType;
        switch (this.isoTypeRef.nativeElement.selectedIndex) {
          case 0: 
            if (this.sigObj?.canEncrypt()) {
              alert("The selected type should be encrypted");
            } else {
              name = "signature_2007.iso";
              isoType = this.sigSDK.IsoType.ISO19794_7_2007_BINARY;
            }
            break;
          case 1:
            if (this.sigObj?.canEncrypt()) {
              alert("XML ISO does not support encryption");
              return;
            } else {
              name = "signature.xml";
              isoType = this.sigSDK.IsoType.ISO19785_3_2015_XML;
            }
            break;
          case 2:
            if (!this.sigObj?.canEncrypt()) {
              alert("No encryption options setted");              
            } else {
              name = "signature_2007_encrypted_binary.iso"
              isoType = this.sigSDK.IsoType.ISO19794_7_2007_ENCRYPTED_BINARY;
            }
            break;
          case 3:
            if (!this.sigObj?.canEncrypt()) {
              alert("No encryption options setted");              
            } else {
              name = "signature_2007_encrypted_text.iso"
              isoType = this.sigSDK.IsoType.ISO19794_7_2007_ENCRYPTED_TEXT;
            }
            break;
          case 4: 
            if (this.sigObj?.canEncrypt()) {
              alert("The selected type should be encrypted");
            } else {
              name = "signature_2014.iso";
              isoType = this.sigSDK.IsoType.ISO19794_7_2014_BINARY;
            }
            break;
          case 5:
            if (!this.sigObj?.canEncrypt()) {
              alert("No encryption options setted");              
            } else {
              name = "signature_2014_encrypted_binary.iso"
              isoType = this.sigSDK.IsoType.ISO19794_7_2014_ENCRYPTED_BINARY;
            }
            break;
          case 6:
            if (!this.sigObj?.canEncrypt()) {
              alert("No encryption options setted");              
            } else {
              name = "signature_2014_encrypted_text.iso"
              isoType = this.sigSDK.IsoType.ISO19794_7_2014_ENCRYPTED_TEXT;
            }
            break;
          case 7: 
            if (this.sigObj?.canEncrypt()) {
              alert("The selected type should be encrypted");
            } else {
              name = "signature_2021.iso";
              isoType = this.sigSDK.IsoType.ISO19794_7_2021_BINARY;
            }
            break;
          case 8:
            if (!this.sigObj?.canEncrypt()) {
              alert("No encryption options setted");              
            } else {
              name = "signature_2021_encrypted_binary.iso"
              isoType = this.sigSDK.IsoType.ISO19794_7_2021_ENCRYPTED_BINARY;
            }
            break;
          case 9:
            if (!this.sigObj?.canEncrypt()) {
              alert("No encryption options setted");              
            } else {
              name = "signature_2021_encrypted_text.iso"
              isoType = this.sigSDK.IsoType.ISO19794_7_2021_ENCRYPTED_TEXT;
            }
            break;
        }
        if (name) {
			    newLink.download = name;
          blob = new Blob([await this.sigObj?.exportIso(isoType)], { type: "application/octet-stream" });
        } else {
          return;
        }		
			}
					
			if (window.webkitURL != null) {
        newLink.href = window.webkitURL.createObjectURL(blob!);
      } else {
        newLink.href = window.URL.createObjectURL(blob!);
        newLink.style.display = "none";
        document.body.appendChild(newLink);
      }
	  }
				
    newLink.click(); 
		newLink.remove();
	}

  private async encryptSignature() {
		try {
			if (this.noEncryptionRef.nativeElement.checked) {
			  await this.sigObj?.setPublicKey("");
				await this.sigObj?.setPrivateKey("");
			} else {
 				if (this.symmetricEncryptionRef.nativeElement.checked) {
				  await this.sigObj?.setEncryptionPassword(this.symmetricPasswordRef.nativeElement.value);												
				} else if (this.asymmetricEncryptionRef.nativeElement.checked) {
					const pubKey = this.publicKeyRef.nativeElement.value;
          if (pubKey !== "") {								
					  await this.sigObj?.setPublicKey(pubKey);								
					}
				}
						
				if (!this.sigObj?.canEncrypt()) {
					alert("The signature cannot be encrypted");
				}
			}
		} catch (e) {
			alert(e);
		}
	}

  public loadBackgroundImage(): void {
    const outer = this;
		const file = this.backgroundImageRef.nativeElement.files[0];
	  if (file) {
			const reader = new FileReader();
      reader.onload = async function() {
        const data = reader.result as string;
		    outer.backgroundImage = new Image();	     
	      outer.backgroundImage.src = data;  
			}
      reader.readAsDataURL(file);										    
		}
	}

  private async getSystemInfo(): Promise<[string, string]> {
    let browserInfo: string = "";
    let osInfo: string = "";
	  const navigatorUAData = (window.navigator as any).userAgentData;
    if (navigatorUAData) {
      const values = await navigatorUAData.getHighEntropyValues(["platformVersion"]);
	    const brandList = ['chrome', 'opera', 'safari', 'edge', 'firefox'];
		
	    let found = false;
	    for (const agentBrand of values.brands) {
	      const agentBrandEntry = agentBrand.brand.toLowerCase();
	 	    const foundBrand = brandList.find(brand => agentBrandEntry.includes(brand));

		    if (foundBrand) {
          browserInfo = agentBrand.brand + " " + agentBrand.version;
		      found = true;
          break
        }
	    }
		
	    if (!found) {
		    browserInfo = values.brands[0].brand + " " + values.brands[0].version;
	    }		
		  
	    osInfo = values.platform + " " + values.platformVersion;
    } else {
      browserInfo = navigator.userAgent;
      osInfo = "Unkwon OS";	        
    }

    return [browserInfo, osInfo];
  }
}